import { ChannelAppTabAction } from '../../services';
import { StoryTabType } from '../models';

export const getAppTabActionByStoryTabType = (storyTabType: StoryTabType) => {
  switch (storyTabType) {
    case StoryTabType.storyTab1:
      return ChannelAppTabAction.STORIES;
    case StoryTabType.storyTab2:
      return ChannelAppTabAction.STORIES_2;
    case StoryTabType.storyTab3:
      return ChannelAppTabAction.STORIES_3;
    case StoryTabType.storyTab4:
      return ChannelAppTabAction.STORIES_4;
    case StoryTabType.storyTab5:
      return ChannelAppTabAction.STORIES_5;
    case StoryTabType.pinnedStoryTab:
      return ChannelAppTabAction.PINNED_STORY;
    case StoryTabType.pinnedStoryTab2:
      return ChannelAppTabAction.PINNED_STORY_2;
    case StoryTabType.pinnedStoryTab3:
      return ChannelAppTabAction.PINNED_STORY_3;
    case StoryTabType.pinnedStoryTab4:
      return ChannelAppTabAction.PINNED_STORY_4;
    case StoryTabType.pinnedStoryTab5:
      return ChannelAppTabAction.PINNED_STORY_5;
  }
};
